import type { ReactNode } from 'react'
import type { OrderStatus, PolicyStatus } from '../lib/customers-api'
import type { PaymentStatus } from '../lib/sales-api'

export type Tone = 'good' | 'bad' | 'warn' | 'neutral'

const toneClass: Record<Tone, string> = {
  good: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300',
  bad: 'bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300',
  warn: 'bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300',
  neutral: 'bg-sunken text-strong',
}

export const ORDER_TONE: Record<OrderStatus, Tone> = {
  DRAFT: 'neutral',
  PENDING_PAYMENT: 'neutral',
  PAYMENT_FAILED: 'bad',
  PAID: 'neutral',
  ISSUING: 'neutral',
  ISSUED: 'good',
  ISSUE_FAILED: 'bad',
  CANCELLED: 'bad',
}

export const PAYMENT_TONE: Record<PaymentStatus, Tone> = {
  CREATED: 'neutral',
  REDIRECTED: 'neutral',
  SUCCEEDED: 'good',
  FAILED: 'bad',
  CANCELLED: 'bad',
}

export const POLICY_TONE: Record<PolicyStatus, Tone> = {
  UPCOMING: 'neutral',
  ACTIVE: 'good',
  EXPIRED: 'bad',
}

export function Badge({ tone, children }: { tone: Tone; children: ReactNode }) {
  return (
    <span
      className={`inline-block whitespace-nowrap rounded-lg px-2 py-0.5 text-xs font-medium ${toneClass[tone]}`}
    >
      {children}
    </span>
  )
}
